import { CyBeamer } from "./CyBeamer";
import { BeamerScreen } from "./BeamerScreen";
import { useFullscreen } from "./useFullscreen";

export function SongsheetBeamerView() {
  const fullscreen = useFullscreen();

  return (
    <div style={{ height: "100vh" }}>
      <BeamerScreen fullscreen={fullscreen} data-cy={CyBeamer.LyricsContent} />
    </div>
  );
}
